import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';

import { Box } from '@hivebrite/design-system/Box';

import { sortByItems } from 'hb-react/frontoffice/apps/PeopleDirectory/constants/sortByItems';
import PeopleDirectory from 'hb-react/frontoffice/apps/PeopleDirectory/startup/PeopleDirectoryAppClient';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { usePageMenuName, PAGES } from 'hb-react/shared/hooks/usePageMenuName';
import { isUserInvitationsAvailable } from 'hb-react/shared/utils/features';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import { getPageTitleFromNetwork } from 'hb-react/shared/utils/getPageTitleFromNetwork';

const TopicMembersContainer = ({ topic: { id, name } }) => {
  const {
    currentUser,
    currentNetwork,
    currentNetwork: {
      features: featuresConfig,
      network_config: networkConfig,
      users_can_invite_all_users: usersCanInviteAllUsers,
    },
  } = useDefaultAppContexts();

  // Waiting for a back-end fix, the value saved and send back is "0" or "1" but not true/false
  const displayLastActiveTagValue =
    featuresConfig?.people_directory?.config?.display_last_active_tag;
  const displayLastActiveTag = !!(
    displayLastActiveTagValue === '1' || displayLastActiveTagValue === true
  );

  const topicsMenuItem = usePageMenuName(PAGES.USERS, __('Members'));

  return (
    <>
      <DocumentTitle
        title={generatePageTitle({
          title: topicsMenuItem,
          networkName: getPageTitleFromNetwork(currentNetwork),
          topicName: name,
        })}
      />
      <Box flexDirection="column" mt={6} width="100%">
        <PeopleDirectory
          config={{
            canInviteInactiveUser:
              isUserInvitationsAvailable(currentNetwork) &&
              currentUser?.can_invite_users,
            usersCanInviteAllUsers,
            canAddUsersToFavorite: networkConfig?.user_bookmarks_enabled,
            userBookmarksLabel: networkConfig?.user_bookmarks_label,
            displayLastActiveTag,
            initialSortBy: sortByItems[0],
            isInsideGroup: true,
            topicId: id,
            mapViewSettings: {
              isMapInitiallyDisplayed: false,
              userCanToggleMap: false,
              initialCenter: [0, 0],
              initialZoom: 1,
            },
            routes: {
              fetchPeopleDirectoryUsers: (routeParams) =>
                Routes.topics_topic_members_path(id, {
                  format: 'json',
                  ...routeParams,
                }),
            },
          }}
        />
      </Box>
    </>
  );
};

TopicMembersContainer.propTypes = {
  topic: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.number.isRequired,
    ]),
  }).isRequired,
};

export default TopicMembersContainer;
